<form class="modal-body" [formGroup]="form" (ngSubmit)="update()" *ngIf="!isVerifyingEmail" novalidate>
  @if (isSigningFlow) {
    <p class="centermodal__title">{{ 'profile.personalData' | translate }}</p>
    <p class="centermodal__description">{{ 'documents.completePersonalInfo' | translate }}</p>
  } @else {
    <p class="centermodal__title">{{ (this.forceEdit ? 'settings.changeProfileData' : 'profile.completeRegistration') | translate }}</p>
  }

  <div class="centermodal__form">
    <ng-container formGroupName="user">
      <label class="field__holder" [appFormControlWrap]="form.get('user.email')" *ngIf="form.get('user.email')">
        <input type="email" class="field" formControlName="email" name="email" autocomplete="email" [appDisableInput]="isFixedEmail" required appValidEmail />
        <span class="field__placeholder">{{ 'profile.email' | translate }}</span>
      </label>
      <label class="field__holder" [appFormControlWrap]="form.get('user.name')" *ngIf="form.get('user.name')">
        <input type="text" class="field" formControlName="name" name="name" autocomplete="name" required appValidName appFullName appForbiddenNames [appMatchName]="forceNameAs" />
        <span class="field__placeholder">{{ 'profile.fullName' | translate }}</span>
      </label>

      <label class="field__holder" [appFormControlWrap]="form.get('user.password')" *ngIf="form.get('user.password')">
        <input type="password" class="field" formControlName="password" name="password" autocomplete="password" required minlength="8" appShowPassword data-sentry-mask />
        <span class="field__placeholder">{{ 'settings.setPassword' | translate }}</span>
      </label>

      <div class="d-flex">
        @if ((forceCpfAs || !ignoreCpf) && form.get('user.cpf')) {
          <div class="w-60">
            <label class="field__holder" [appFormControlWrap]="form.get('user.cpf')">
              <input type="tel" class="field" formControlName="cpf" name="cpf" autocomplete="cpf" mask="000.000.000-00" appValidCpf [appMatchCpf]="forceCpfAs" required />
              <span class="field__placeholder">{{ 'profile.cpf' | translate }}</span>
            </label>
          </div>
        }
        @if (!ignoreBirthdate && form.get('user.birthday')) {
          <div class="w-40">
            <label class="field__holder" [appFormControlWrap]="form.get('user.birthday')">
              <input
                type="tel"
                class="field"
                formControlName="birthday"
                name="birthday"
                autocomplete="birthday"
                mask="00/00/0000"
                [dropSpecialCharacters]="false"
                [specialCharacters]="['/']"
                [required]="!ignoreBirthdate"
                [appValidDate]="currentUser?.locale?.date_format"
                [appMatchBirthdate]="forceBirthdateAs"
              />
              <span class="field__placeholder">{{ 'profile.birthDate' | translate }}</span>
            </label>
          </div>
        }
      </div>
    </ng-container>
    @if (!ignoreLocale) {
      <div class="d-flex" formGroupName="locale">
        @if (form.get('locale.country')) {
          <div class="w-70" [appFormControlWrap]="form.get('locale.country')">
            <app-select placeholder="{{ 'profile.country' | translate }}" formControlName="country" [options]="countries" [required]="true"></app-select>
          </div>
        }
        @if (form.get('locale.language')) {
          <div class="w-30" [appFormControlWrap]="form.get('locale.language')">
            <app-select
              placeholder="{{ 'profile.language' | translate }}"
              formControlName="language"
              (click)="changeLanguage(form.get('locale.language').value)"
              [disableSearch]="true"
              [options]="languages"
            ></app-select>
          </div>
        }
      </div>
    }
  </div>

  <ng-container [ngTemplateOutlet]="modalButtons"></ng-container>
</form>

<div class="modal-body" *ngIf="isVerifyingEmail">
  <app-email-verify [verifier]="currentUser.email" [email]="currentUser.email" (verified)="modal.close()">
    <ng-container [ngTemplateOutlet]="modalButtons"></ng-container>
  </app-email-verify>
</div>

<ng-template #modalButtons>
  <div class="centermodal__button-group">
    <button type="button" class="btn-M btn-filled-cancel" [disabled]="isLoading" (click)="modal.dismiss()">{{ 'button.close' | translate }}</button>
    <button type="submit" class="btn-M btn-filled" [disabled]="form.invalid || isLoading">{{ 'button.continue' | translate }}</button>
  </div>
</ng-template>
